import { AxiosResponse } from 'axios';
import { useInfiniteQuery, UseInfiniteQueryResult } from 'react-query';
import { PaginatedNotificationMessageTemplateList, UrlParams } from 'types';
import { client } from 'utils/api-client';
import { encodeUrlParams, urlParamsFromUrl } from 'utils/functions';

interface QueryKeyType {
  pageParam?: UrlParams;
  queryKey: (string | undefined)[];
}

interface IUseNotificationMessageTemplates {
  ordering?: string;
  search?: string;
  limit?: string;
}

function useNotificationMessageTemplates({
  ordering,
  search,
  limit = '20',
}: IUseNotificationMessageTemplates): UseInfiniteQueryResult<
  AxiosResponse<PaginatedNotificationMessageTemplateList>
> {
  const fetchNotificationMessageTemplates = ({
    pageParam = { limit, offset: '0' },
  }: QueryKeyType): Promise<AxiosResponse<PaginatedNotificationMessageTemplateList>> => {
    const params = pageParam;

    if (search) {
      params.search = search;
    }

    if (ordering) {
      params.ordering = ordering.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`).concat(',pk');
    }

    return client.get(`notification-message-templates/?${encodeUrlParams(params)}`);
  };

  return useInfiniteQuery(
    ['notificationMessageTemplates', search, ordering],
    fetchNotificationMessageTemplates,
    {
      getNextPageParam: page => {
        return page.data.next ? urlParamsFromUrl(page.data.next) : undefined;
      },
    },
  );
}

export default useNotificationMessageTemplates;
